// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"LoaderSpinner_spinnerContainer__GGZDi","spinner":"LoaderSpinner_spinner__JopKj","rotate":"LoaderSpinner_rotate__olPX1"};